import actionTypes from '../constants/action-types';

const setMetaTranslations = (translations) => ({
  type: actionTypes.SET_META_TRANSLATIONS,
  payload: {
    translations,
  },
});

export default setMetaTranslations;
